import React, { Component } from "react";
import "./Share.scss";
import ShareState from "./ShareState";

/**
 * @typedef {Object} ShareProps
 * @property {ShareState} store - The share state store
 */

class Share extends Component {
  /**
   * @param {ShareProps} props
   */
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    let url = `${window.location.href.split("#")[0]}#likes=0&shared=1`;
    if (this.props.store.searchState.shortLinkType === "track") {
      url = `${window.location.origin}/en/single_keyword_search/?${encodeURIComponent(
        `${this.props.store.searchState.shortLinkTrackName}`
      )}#mobile`;
    }

    this.props.store.searchState.getShortLink(url);
  }

  componentWillUnmount() {
    this.props.store.searchState.clearShortLink();
  }

  copyToClipboard = (e) => {
    if (this.isOS()) {
      this.input.select();
      document.execCommand("copy");
      e.target.focus();
    } else {
      this.props.store
        .copyTextToClipboard(this.props.store.searchState.shortLink)
        .then(() => {})
        .catch(err => {
          console.log(err);
        });
    }
    this.props.store.searchState.toggleSharePopup();
  };

  isOS = () => navigator.userAgent.match(/ipad|iphone/i);

  render() {
    // const linkType = "playlist";
    const verbiage = `press to copy link to clipboard`;

    return (
      <div className={"Share"}>
        <div className={"Share-holder"}>
          <div
            className={`Share-header  ${
              this.props.store.hasBeenCopied ? "active" : ""
            }`}
          >
            <span className={`icon`} />
            <p>{verbiage}</p>
          </div>
          <div
            className={"Popup-banner-close"}
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              this.props.store.searchState.toggleSharePopup();
            }}
          />
          <div className={"Share-content-holder"}>
            <div>
              <input
                readOnly={"readonly"}
                ref={input => (this.input = input)}
                defaultValue={this.props.store.searchState.shortLink}
              />
            </div>
            <div className={"buttons"}>
              <button
                type={"button"}
                className={"Popup-button red"}
                onClick={this.copyToClipboard}
              >
                copy
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Share;
